import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import './index.css'
import { AuthProvider, RequireStaff } from './lib/auth'
import { FertilizerPage } from './pages/fertilizer-page'
import { FertilizersPage } from './pages/fertilizers-page'
import { LoginPage } from './pages/login-page'
import { OrganizationsPage } from './pages/organizations-page'
import { PesticidePage } from './pages/pesticide-page'
import { PesticidesPage } from './pages/pesticides-page'
import { UsersPage } from './pages/users-page'

const PAGES = [
  { path: '/pesticides', page: <PesticidesPage /> },
  { path: '/pesticides/:pesticideId', page: <PesticidePage /> },
  { path: '/fertilizers', page: <FertilizersPage /> },
  { path: '/fertilizers/:fertilizerId', page: <FertilizerPage /> },
  { path: '/organizations', page: <OrganizationsPage /> },
  { path: '/users', page: <UsersPage /> },
]

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Navigate to="/pesticides" replace />} />
          {PAGES.map(({ path, page }) => (
            <Route key={path} path={path} element={<RequireStaff>{page}</RequireStaff>} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
